import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Grid } from '@mui/material';
import TopNavBar from '../../Components/TopBar/Navbar';
import ReferralTable from './ReferralTable';

import { useReferral } from './useReferral';
import { ReferralCodeModal } from './ReferralCodeModal';
import { useUserContext } from '../../context/user.context';
import { AirdropMissions } from '../../Components/AirdropMissions/AirdropMissions';
import { AirdropStats } from './AirdropStats';
import { isDisabled } from '../../utils/constants';
import { useAirdrop } from './useAirdrop';

const AirdropPage = () => {
  const { isLoggedIn, profileData } = useUserContext();
  const { referralCode: referralCodeParam } = useParams();
  const [isRedeemModalOpen, setIsRedeemModalOpen] = useState(false);
  const { isAirdropPaused } = useAirdrop();

  const {
    redeemReferralCode,
    referralCode,
    referralInvites,
    isLoading: isReferralLoading,
  } = useReferral();

  useEffect(() => {
    if (isLoggedIn && !profileData.invitedByUserId) {
      setIsRedeemModalOpen(true);
    }
  }, [profileData]);

  return (
    <Grid
      container
      gap="50px"
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'start'}
      className="airdrop_page"
    >
      <Grid container zIndex={100}>
        <TopNavBar />
      </Grid>

      {isAirdropPaused && (
        <Grid
          item
          lg={8}
          md={10}
          sm={12}
          xs={12}
          display={'flex'}
          flexDirection={'column'}
          className="mx-auto"
        >
          <p className="landingHeadingPaused text-center">Coming soon</p>
        </Grid>
      )}

      <div className="section-container">
        <Grid
          container
          gap="50px"
          display={'flex'}
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'center'}
          className=""
        >
          <AirdropStats />

          <AirdropMissions
            referralCode={referralCode}
            setIsRedeemModalOpen={setIsRedeemModalOpen}
          />

          <ReferralTable
            referralInvites={referralInvites}
            referralCode={referralCode}
            isLoading={isReferralLoading}
          />
        </Grid>
      </div>

      {!isDisabled && isRedeemModalOpen && (
        <ReferralCodeModal
          redeemReferralCode={redeemReferralCode}
          referralCode={referralCodeParam}
          isModalOpen={isRedeemModalOpen}
          setIsRedeemModalOpen={setIsRedeemModalOpen}
        />
      )}
    </Grid>
  );
};

export default AirdropPage;
